<div class="w-[18px] h-[18px] bg-[#0059890F] flex items-center justify-center rounded-full">
  <span data-test-id="step-number" class="text-blue-400 text-sm font-bold">{{ stepNumber }}</span>
</div>
